import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: "Becario/a - Prácticas", text: $t('data.levels.Becario/a - Prácticas', 'Becario/a - Prácticas') },
    { value: "Becario/a - Formación Profesionals", text: $t('data.levels.Becario/a - Formación Profesionals', 'Becario/a - Formación Profesionals') },
    { value: "Becario/a - Grado universitario o Máster", text: $t('data.levels.Becario/a - Grado universitario o Máster', 'Becario/a - Grado universitario o Máster') },
    { value: "Empleado/a", text: $t('data.levels.Empleado/a', 'Empleado/a') },
    { value: "Especialista", text: $t('data.levels.Especialista', 'Especialista') },
    { value: "Mando intermedio", text: $t('data.levels.Mando intermedio', 'Mando intermedio') },
    { value: "Dirección / gerencia", text: $t('data.levels.Dirección / gerencia', 'Dirección / gerencia') },
    { value: "Consejo directivo", text: $t('data.levels.Consejo directivo', 'Consejo directivo') },
];
